
import React, { useState } from "react";
import cx from "classnames";
import styles from "./common.module.scss";
import { downloadAllPages } from "src/services/experiences/leadsAndReports/reports";
import { buildCsv, triggerCsvDownload } from "src/services/experiences/leadsAndReports/csv";
import { PagedResponse } from "src/types/experiences/leadsAndReports";

interface ExportCsvButtonProps {
  label?: string;
  filename?: string;
  headers: { label: string; key: string }[];
  // eslint-disable-next-line no-unused-vars
  mapRows: (records: any[]) => Record<string, unknown>[];
  // eslint-disable-next-line no-unused-vars
  fetchPage: (page: number, limit: number) => Promise<PagedResponse>;
  limit?: number;
  className?: string;
}

export const ExportCsvButton: React.FC<ExportCsvButtonProps> = ({
  label = "Download",
  filename = "Report.csv",
  headers,
  mapRows,
  fetchPage,
  limit = 50,
  className,
}) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const records = await downloadAllPages(fetchPage, limit);
      const csv = buildCsv(headers, mapRows(records));
      triggerCsvDownload(csv, filename);
    } catch (error) {
      console.error("CSV export failed:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      className={cx(styles.downloadAction, className)}
      onClick={handleClick}
      disabled={loading}
    >
      <i className="paperflite-download" />
      {loading ? "Downloading…" : label}
    </button>
  );
};
